"use client";

import { BSRChevronLeft } from "./bsr/BSRChevronLeft";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ChevronLeft as LegacyChevronLeft } from "./legacy/ChevronLeft";

export const ChevronLeft = createBSRExperimentIcon(
  LegacyChevronLeft,
  BSRChevronLeft
);
